import { ErrorMessage } from "components/Messages";
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import "./basemodal.scss"


const getStyle = ({
  width,
  height,
  bgcolor = "var(--bg-page)",
  borderColor = "var(--bg-muted)",
  fontColor = "var(--text-primary)",
}) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor,
    border: `3px solid ${borderColor}`,
    borderRadius: '8px',
    color: fontColor,
    boxShadow: 24,
    pt: 5,
    px: 5,
    pb: 10,
  };

  if (width) style.width = width;
  if (height) style.height = height;

  return style;
};


const BaseModal = ({
    title,
    description,
    width, height, fontColor, bgcolor,borderColor,
    setOpen,
    content,
    error
}) => {

    return (
        <Modal
            open={setOpen}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="mainModal"
        >
        <Fade in={setOpen} timeout={300}>
            <Box sx={
                getStyle({ width, height, fontColor, bgcolor, borderColor})
            }>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                {title}
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                { description }
            </Typography>
            <Typography id="modal-modal-content" component="div" sx={{ mt: 4 }}>
                { content }
                { error && <ErrorMessage message={error}/> }
            </Typography>
            </Box>
        </Fade>
        </Modal>
    );
}

export default BaseModal;